import { CLAN_BATTLES_TABS, CLAN_WARS_TABS, PATROLS_TABS, REQUESTS_TABS, TREASURY_TABS } from '~/constants';

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// ⚠️  IMPORTANT: When changing routes, update WILDCARD_PREFIXES in:
//     wsclans/apps/portal/handlers.py
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
export enum ROUTES_MAP {
  ROOT = '',
  ABOUT = 'about',
  CLAN_BATTLES = 'clan-battles',
  CLAN_BATTLES_HALL = `${CLAN_BATTLES}/${CLAN_BATTLES_TABS.HALL}`,
  CLAN_BATTLES_HISTORY = `${CLAN_BATTLES}/${CLAN_BATTLES_TABS.HISTORY}`,
  CLAN_BATTLES_RATING = `${CLAN_BATTLES}/${CLAN_BATTLES_TABS.RATING}`,
  CLAN_BATTLES_RULES = `${CLAN_BATTLES}/${CLAN_BATTLES_TABS.RULES}`,
  CLAN_CREATE = 'create',
  CLAN_PROFILE = 'clan-profile/:clanId',
  CLAN_PROFILE_MEMBERS = `${CLAN_PROFILE}/members`,
  CLAN_STARS = 'clanstars',
  CLAN_WARS = 'clan-wars',
  CLAN_WARS_RATING = `${CLAN_WARS}/${CLAN_WARS_TABS.RATING}`,
  CLAN_WARS_RULES = `${CLAN_WARS}/${CLAN_WARS_TABS.RULES}`,
  CLAN_WARS_WAR = `${CLAN_WARS}/${CLAN_WARS_TABS.WAR}`,
  CLAN_WARS_WELCOME = `${CLAN_WARS}/${CLAN_WARS_TABS.WELCOME}`,
  MEMBERS = 'members',
  PROFILE = 'profile',
  REQUESTS = 'requests',
  REQUESTS_APPLICATIONS = `${REQUESTS}/${REQUESTS_TABS.APPLICATION}`,
  REQUESTS_INVITES = `${REQUESTS}/${REQUESTS_TABS.INVITES}`,
  SEARCH = 'search',
  SEARCH_RECOMMENDATIONS = `${SEARCH}/:purpose/:currentSlide`,
  TASKS = 'tasks',
  TREASURY = 'treasury',
  TREASURY_DISTRIBUTION = `${TREASURY}/${TREASURY_TABS.DISTRIBUTION}`,
  TREASURY_EXPENSES = `${TREASURY}/${TREASURY_TABS.EXPENSES}`,
  TREASURY_INCOME = `${TREASURY}/${TREASURY_TABS.INCOME}`,
  TREASURY_REWARDS = `${TREASURY}/${TREASURY_TABS.REWARDS}`,
  PATROLS = 'patrols',
  PATROLS_ACTIVE = `${PATROLS}/${PATROLS_TABS.ACTIVE}`,
  PATROLS_LIST = `${PATROLS}/${PATROLS_TABS.LIST}`,
  PATROLS_RULES = `${PATROLS}/${PATROLS_TABS.RULES}`,
}

export enum ROUTES_BADGES {
  CLAN_BATTLES = 'clan-battles',
  CLAN_STARS = 'clanstars',
  CLAN_WARS = 'clan-wars',
  CREATE = 'create',
  MEMBERS = 'members',
  PROFILE = 'profile',
  RECOMMENDATIONS = 'recommendations',
  RECOMMENDATIONS_NEW = 'new-recommendations',
  REQUESTS = 'requests',
  SEARCH = 'search',
  TASKS = 'tasks',
  PATROLS = 'patrols',
}

export enum ROUTES_BADGES_TYPES {
  NONE = 'none',
  COUNTER = 'counter',
  NEW = 'new',
  REWARD = 'reward',
}

export enum ROUTES_PROGRESS_TYPES {
  NONE = 'none',
  PROFILE_SUPPLY = 'profile_supply',
}

export enum ROUTES_SECTIONS {
  ABOUT_CLANS = 'about-clans',
  CLAN_EXTERNAL = 'clan-external',
  CLAN_MANAGEMENT = 'clan-management',
}
